import {
  bigint,
  index,
  pgTable,
  timestamp,
  uuid,
  varchar,
} from 'drizzle-orm/pg-core';
import {
  defaultFields,
  defaultHistoryFields,
} from '@trashlab/api/drizzle/default';

export const workflow_state = pgTable(
  'workflow_state',
  {
    ...defaultFields.fieldsWithTenantId(),
    deliveryStartedDrivingAtTs: timestamp('deliveryStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    deliveryLoadedAtTs: timestamp('deliveryLoadedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    deliveryCompletedAtTs: timestamp('deliveryCompletedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    removalStartedDrivingAtTs: timestamp('removalStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    removalDumpedAtTs: timestamp('removalDumpedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    removalCompletedAtTs: timestamp('removalCompletedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpDumpedAtTs: timestamp('dumpDumpedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpStartedDrivingAtTs: timestamp('dumpStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpAndReturnDeliveredAtTs: timestamp('dumpAndReturnDeliveredAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpAndReturnDumpedAtTs: timestamp('dumpAndReturnDumpedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpAndReturnRemovedAtTs: timestamp('dumpAndReturnRemovedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    dumpAndReturnStartedDrivingAtTs: timestamp(
      'dumpAndReturnStartedDrivingAtTs',
      { withTimezone: true, mode: 'string' },
    ),
    swapDeliveredAtTs: timestamp('swapDeliveredAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    swapDumpedAtTs: timestamp('swapDumpedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    swapLoadedAtTs: timestamp('swapLoadedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    swapRemovedAtTs: timestamp('swapRemovedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    swapStartedDrivingAtTs: timestamp('swapStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    liveloadDumpedAtTs: timestamp('liveloadDumpedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    liveloadFilledAtTs: timestamp('liveloadFilledAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    liveloadLoadedAtTs: timestamp('liveloadLoadedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    liveloadStartedDrivingAtTs: timestamp('liveloadStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    customCompletedAtTs: timestamp('customCompletedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    customStartedDrivingAtTs: timestamp('customStartedDrivingAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    removalRemovedAtTs: timestamp('removalRemovedAtTs', {
      withTimezone: true,
      mode: 'string',
    }),
    lastModifiedBy: uuid('lastModifiedBy'),
    createdBy: uuid('createdBy'),
    legacySystemId: varchar('legacySystemId', { length: 255 }),
  },
  (table) => {
    return {
      createdAtTs_idx: index('workflow_state_createdAtTs_idx').on(
        table.createdAtTs,
      ),
      tenantId_idx: index('workflow_state_tenantId_idx').on(table.tenantId),
      updatedAtTs_idx: index('workflow_state_updatedAtTs_idx').on(
        table.updatedAtTs,
      ),
      updatedAtTs_idx1: index('workflow_state_updatedAtTs_idx1').on(
        table.updatedAtTs.desc(),
      ),
      versionNumber_idx: index('workflow_state_versionNumber_idx').on(
        table.versionNumber,
      ),
    };
  },
);

export const workflow_state_history = pgTable('workflow_state_history', {
  ...defaultHistoryFields.historyFieldsWithTenantId(),
  deliveryStartedDrivingAtTs: timestamp('deliveryStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  deliveryLoadedAtTs: timestamp('deliveryLoadedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  deliveryCompletedAtTs: timestamp('deliveryCompletedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  removalStartedDrivingAtTs: timestamp('removalStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  removalDumpedAtTs: timestamp('removalDumpedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  removalCompletedAtTs: timestamp('removalCompletedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpDumpedAtTs: timestamp('dumpDumpedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpStartedDrivingAtTs: timestamp('dumpStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpAndReturnDeliveredAtTs: timestamp('dumpAndReturnDeliveredAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpAndReturnDumpedAtTs: timestamp('dumpAndReturnDumpedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpAndReturnRemovedAtTs: timestamp('dumpAndReturnRemovedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  dumpAndReturnStartedDrivingAtTs: timestamp(
    'dumpAndReturnStartedDrivingAtTs',
    { withTimezone: true, mode: 'string' },
  ),
  swapDeliveredAtTs: timestamp('swapDeliveredAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  swapDumpedAtTs: timestamp('swapDumpedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  swapLoadedAtTs: timestamp('swapLoadedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  swapRemovedAtTs: timestamp('swapRemovedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  swapStartedDrivingAtTs: timestamp('swapStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  liveloadDumpedAtTs: timestamp('liveloadDumpedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  liveloadFilledAtTs: timestamp('liveloadFilledAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  liveloadLoadedAtTs: timestamp('liveloadLoadedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  liveloadStartedDrivingAtTs: timestamp('liveloadStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  customCompletedAtTs: timestamp('customCompletedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  customStartedDrivingAtTs: timestamp('customStartedDrivingAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  removalRemovedAtTs: timestamp('removalRemovedAtTs', {
    withTimezone: true,
    mode: 'string',
  }),
  lastModifiedBy: uuid('lastModifiedBy'),
  createdBy: uuid('createdBy'),
  legacySystemId: varchar('legacySystemId', { length: 255 }),
});
